// The controls strip above an answer-variants block, ported from Items.ControlsView.
//
// It offers two things, each to a question that earns it: the word-cloud toggle to a question with
// enough variants to be worth clouding, and the verbatim export to a question that collects any.

import { getFeatures, getModelValue, isGuest, isReportVirtual, isReportXpert } from '@aytm/app/stats/lib/stat-page'
import {
  isVerbatimType as calcIsVerbatimType,
  isWCType as calcIsWCType
} from '@aytm/app/stats/page/components/lib/utils'

const CONTROLS_FEATURES = ['oe_tags_management', 'oe_tags_view', 'oe_sentiments_management', 'oe_sentiments_view']

export const calcControlsProps = ({
  id,
  questionKey,
  type,
  variant,
  questionId,
  questionType,
  batches,
  answerVariants,
  disabled,
  chartMode,
  handlers = {}
} = {}) => {
  const features = getFeatures()

  return {
    model: {
      id,
      key: questionKey,
      type,
      items: answerVariants || null,
      chartMode: chartMode || getModelValue('chartMode')
    },
    disabled,
    isWCType: calcIsWCType({ type, variant, questionType, batches, answerVariants }),
    isVerbatimType: calcIsVerbatimType({
      type,
      variant,
      questionId,
      questionType,
      isReportVirtual: isReportVirtual(),
      isReportXpert: isReportXpert()
    }),
    isSurveyGuest: isGuest(),
    features: CONTROLS_FEATURES.reduce((acc, token) => Object.assign(acc, { [token]: features[token] }), {}),
    onChartModeChange: handlers.onChartModeChange,
    onExport: handlers.onExport
  }
}
